/* eslint-disable import/no-duplicates */
import FlashOnFill from '@atom-web/icons-24/FlashOnFill'
import Star from '@atom-web/icons-24/jsx/Star'
import { Column, Flex, Row, Text } from '@atom-web/micros'
import truncate from 'lodash/truncate'
import Image from 'next/image'

import DisplayPrice from '../../../../components/DisplayPrice'
import customImageLoader from '../../../../utils/customImageLoader'
import getImgIXUrl from '../../../../utils/getImgIXUrl'
import redirector from '../../../../utils/redirector'

export default ({ data = [], displayCurrency }) => {
	return (
		<>
			<Column>
				<Row gap="1" align="center">
					<FlashOnFill fill="#01C684" width={32} height={32} />
					<Text
						css={{
							fontSize: '17px',
							fontWeight: '$bolder',
							color: '#2c2f42',
							lineHeight: 1.41,
						}}
					>
						Flash Deals
					</Text>
				</Row>
				<Text
					css={{
						fontSize: '17px',
						lineHeight: 1.41,
						letterSpacing: '-0.25px',
						color: '#777777',

						'@smMax': {
							display: 'none',
						},
					}}
				>
					Limited-time discounts on luxury resorts to add more charm to your
					island getaway
				</Text>
			</Column>
			<Flex
				css={{
					width: '100%',
					flexWrap: 'wrap',
					padding: '24px 0px',
					rowGap: '$6',
					columnGap: '$4',

					'@smMax': {
						flexWrap: 'nowrap',
						padding: '12px 0',
						overflow: 'scroll',
					},
				}}
			>
				{data.map(
					(
						{ imageURL, resortName, starRating, startsAtPrice, hotelSlug },
						index,
					) => (
						<Column
							key={'flash-deal-' + index}
							gap={2}
							css={{
								width: index === 0 ? 'calc(50% - 12px)' : 'calc(25% - 12px)',
								cursor: 'pointer',

								'@smMax': {
									width: '100%',
									border: '1px solid #d4d4d4',
									borderRadius: '$2',
								},
							}}
							onClick={() => redirector(`/${hotelSlug}`, '__blank')}
						>
							<Column
								gap={3}
								css={{
									position: 'relative',
									borderRadius: '3px',
									height: index === 0 ? '556px' : '200px',
									width: '100%',
									'@smMax': {
										width: '278px',
										height: '160px',
									},
								}}
							>
								<Image
									unoptimized
									objectFit="cover"
									src={
										getImgIXUrl(
											imageURL,
											`h=${index === 0 ? '556' : '200'}&w=${
												index === 0 ? '540' : '200'
											}&fit=crop`,
										) ||
										'https://pyt-images.imgix.net/images/costing_screen/placeholder/desktop/hotels.png'
									}
									loader={customImageLoader}
									layout="fill"
									className="flash-deal"
								/>
							</Column>
							<Column
								gap={1}
								css={{
									'@smMax': {
										gap: '$2',
									},
								}}
							>
								<Text
									as="p"
									css={{
										fontSize: '18px',
										fontWeight: '$bolder',
										lineHeight: 1.33,
										letterSpacing: '-.29px',

										'@smMax': {
											fontSize: '17px',
											paddingLeft: '$4',
										},
									}}
								>
									{truncate(resortName, {
										length: '32',
									})}
								</Text>
								<Row
									gap={1}
									css={{
										'@smMax': {
											paddingLeft: '$4',
										},
									}}
								>
									<Text
										css={{
											fontSize: '13px',
											lineHeight: '16px',
											color: '#444',
										}}
									>
										{starRating}
									</Text>
									<Star fill="#ffc933" />
									<Text
										css={{
											fontSize: '13px',
											lineHeight: '16px',
											color: '#444',
										}}
									>
										hotel
									</Text>
								</Row>
								<Row
									gap={1}
									align="center"
									css={{
										'@smMax': {
											paddingLeft: '$4',
										},
									}}
								>
									<Text
										css={{
											fontSize: '18px',
											lineHeight: '20px',
											color: '#1895b3',
											fontWeight: '$bolder',
										}}
									>
										<DisplayPrice
											objectData={{ value: startsAtPrice }}
											path={'value'}
											defaultValue="0"
											reduxCurrency={displayCurrency}
										/>
									</Text>
									<Text
										css={{
											fontSize: '13px',
											fontWeight: '$bolder',
											lineHeight: '16px',
											color: '#888',
										}}
									>
										for 3 nights
									</Text>
								</Row>
								<Text
									css={{
										fontSize: '13px',
										lineHeight: '16px',
										color: '#888',
										'@smMax': {
											padding: '0 16px 10px',
										},
									}}
								>
									Starting price/couple
								</Text>
							</Column>
						</Column>
					),
				)}
			</Flex>
		</>
	)
}
